import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import {Wrapper, WrapperContent} from './components';

import logo from 'images/general/logo.png';


class Information extends Component {
  render() {
    return (
      <div>
        <Wrapper>
          <Grid>
            <WrapperContent>
              <li>
                <h3>Департамент охорони здоров’я Одеської міської ради</h3>
                <h4>(0482) 32-78-44</h4>
                <h4>gorzdrav@omr.odessa.ua</h4>
              </li>
              <li>
                <Link to="/">
                  <img src={logo} alt="Логотип" />
                </Link>
              </li>
              <li>
                <h2>
                  Одеська міська рада <span>Міський медичний портал</span>
                </h2>
              </li>
            </WrapperContent>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default Information;



// WEBPACK FOOTER //
// ./src/system/information/index.js